import React from 'react';

// Components
import WpImage from '../image/WpImage';

// Types
import { WpImageProps } from '../image/WpImage';
import { Illustrations } from './illustrations.types';

// interface Props extends WpImageProps {
interface Props extends Omit<WpImageProps, 'alt'> {
  src: Illustrations;
  alt?: string;
}

const WpIllustration = ({ src, alt, ...rest }: Props) => {
  const altAttribute = alt || src;
  return <WpImage src={src} alt={altAttribute} {...rest} />;
};

export default WpIllustration;
